import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FilePath = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 16H23C24.654 16 26 14.654 26 13V11C26 9.346 24.654 8 23 8H21.618L20.447 5.659C19.936 4.636 18.907 4 17.764 4H15C13.346 4 12 5.346 12 7V10H8V3C8 2.448 7.552 2 7 2C6.448 2 6 2.448 6 3V23C6 24.654 7.346 26 9 26H12V27C12 28.654 13.346 30 15 30H23C24.654 30 26 28.654 26 27V25C26 23.346 24.654 22 23 22H21.618L20.447 19.659C19.936 18.636 18.907 18 17.764 18H15C13.346 18 12 19.346 12 21V24H9C8.449 24 8 23.551 8 23V12H12V13C12 14.654 13.346 16 15 16ZM14 21C14 20.449 14.449 20 15 20H17.764C18.145 20 18.488 20.212 18.658 20.553L20.105 23.447C20.274 23.786 20.621 24 21 24H23C23.551 24 24 24.449 24 25V27C24 27.551 23.551 28 23 28H15C14.449 28 14 27.551 14 27V21V21ZM14 7C14 6.449 14.449 6 15 6H17.764C18.145 6 18.488 6.212 18.658 6.553L20.105 9.447C20.274 9.786 20.621 10 21 10H23C23.551 10 24 10.449 24 11V13C24 13.551 23.551 14 23 14H15C14.449 14 14 13.551 14 13V7V7Z" />
	</svg>
);

export default FilePath;
